<template>
	<div>
		<h5>BigScreen</h5>
	</div>
</template>

<script>
	export default {
		name: "BigScreen",
	};
</script>

<style scoped></style>
